import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import PrescriptionRecent from '@screens/vision/source/sections/PrescriptionRecent'
import PrescriptionNew from '@screens/vision/source/sections/PrescriptionNew'
import PrescriptionManual from '@screens/vision/source/sections/PrescriptionManual'
import ButtonsFixed, { SpaceButtons } from '@ui/buttons/ButtonsFixed'
import { router } from 'expo-router'
import { useGetLatestPrescriptions } from '@order/hooks/usePrescription'
import ConfigDebugModal from 'features/debug/ConfigDebugModal'

export default function VisionSource() {
  const { t } = useTranslation(['vision'])
  const text = 'vision:source'

  const { hasPrescriptions } = useGetLatestPrescriptions()

  return (
    <>
      <Page stage="vision" validateStaff>
        <Header
          title={t(`${text}.header.title`)}
          desc={t(`${text}.header.desc`)}
        />
        <View className="gap-8 px-8 pb-8">
          <PrescriptionRecent />
          <PrescriptionNew />
          <PrescriptionManual />
        </View>
        {hasPrescriptions && <SpaceButtons />}
      </Page>
      <ConfigDebugModal />
      {hasPrescriptions && (
        <ButtonsFixed
          disableTransitions
          buttons={[
            {
              label: t('vision:source.sections.recent.title'),
              iconEnd: 'arrow-right',
              variant: 'outlined',
              onPress: () => router.navigate('/vision/values'),
            },
          ]}
        />
      )}
    </>
  )
}
